import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { PipesModule } from '../pipes/pipes.module';

import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import {MatSlideToggleModule} from '@angular/material/slide-toggle';


import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { ColorPickerModule } from 'ngx-color-picker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';

import {MatIconModule} from '@angular/material/icon';
import { ChartsModule } from 'ng2-charts';
import { PollRoutingModule } from './poll-routing.module';
import { PollComponent } from './poll.component';
import { PollsComponent } from './polls/polls.component';
import { RatingModule } from 'ng-starrating';

@NgModule({
  declarations: [
    PollComponent,
    PollsComponent
  ],
  exports:[
     PollComponent,
     PollsComponent
  ],
  imports: [
       CommonModule,
       SharedModule,
       PollRoutingModule,
       RatingModule,
       FormsModule,
       ReactiveFormsModule,
       NgxChartsModule,
       BrowserAnimationsModule,
       PipesModule,
       MatTableModule,
       MatPaginatorModule,
       MatSortModule,
       MatDialogModule,
       MatFormFieldModule,
       MatInputModule,
       MatSlideToggleModule,
       NgxMaterialTimepickerModule,
       ColorPickerModule,
       MatCheckboxModule,
       MatSelectModule,
       MatDatepickerModule,
       MatNativeDateModule,
       MatIconModule,
       ChartsModule
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }  ],
  bootstrap: []
})
export class PollModule { }
